import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import MatchingIcon from '../../../../assets/square-transparent-matching.png';
import { BaseStep, BaseStepProps } from '../BaseStep';

const MatchingStartsStep: React.FC<BaseStepProps> = ({ userType, onComplete }) => {
  const navigate = useNavigate();

  const handleViewProfile = () => {
    navigate('/profile/startup/view');
  };

  const handleContinueEditing = () => {
    window.location.href = '/profile/startup';
  };

  return (
    <BaseStep userType={userType} onComplete={onComplete}>
      <div className="flex flex-col items-center justify-center text-center">
        <div className="text-center mt-2 mb-2">
          <div className="inline-flex items-center justify-center bg-emerald-500 rounded-full p-2 mb-2 mx-auto shadow-lg shadow-emerald-500/20">
            <img className="h-24 w-24 object-contain" src={MatchingIcon} alt="Matching" />
          </div>
        </div>

        <div className="text-center text-lg sm:text-xl md:text-2xl font-bold mb-3 text-white">
          Your profile is now live and visible to investors.
        </div>

        <div className="flex flex-col mt-3 items-center text-sm sm:text-base">
          <div className="w-full">
            <p className="text-start flex-col items-center flex text-white">
              You&apos;ll hear from us when any of them wish to connect.
            </p>
          </div>

          <div className="flex flex-col justify-between w-2/3 mt-4 items-center mx-auto">
            <button
              onClick={handleViewProfile}
              className="border-2 border-emerald-500 text-white px-4 py-2 rounded-lg mb-4 hover:bg-emerald-500/10 transition-colors"
            >
              View Profile
            </button>
            <button
              onClick={handleContinueEditing}
              className="text-gray-400 hover:text-gray-300 underline"
            >
              Continue editing your profile
            </button>
          </div>
        </div>

        <div className="flex items-center justify-center mt-4">
          <div className="text-center text-gray-400 italic text-sm sm:text-base mt-4 w-full">
            You can update your notification preferences anytime in your{' '}
            <Link
              to="/settings/notifications"
              className="text-emerald-500 hover:text-emerald-400 underline"
            >
              settings
            </Link>
            .
          </div>
        </div>
      </div>
    </BaseStep>
  );
};

export default MatchingStartsStep;
